import MLink from '@mui/material/Link';
import { httpUrl } from '../utils/urls';

type Props = {
  url?: string;
  raw?: boolean;
};

const UrlLink = ({ url, raw }: Props) => {
  if (!url) {
    return null;
  }
  return (
    <MLink
      href={httpUrl(url)}
      rel="noopener noreferrer"
      sx={{ overflowWrap: 'anywhere', wordBreak: 'break-word' }}
    >
      {raw ? url : url.replace(/^https?:\/\//, '').replace(/\/$/, '')}
    </MLink>
  );
};

export default UrlLink;
